import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@vp/swan';
import { trackTrackingUrlClicked } from '../../../apis/trackingApi';
import { SourcePageContext } from '../../contexts/SourcePageContext';

const handleTrackingUrlClicked = (e, trackingUrl, sourcePage) => {
  e.preventDefault(); // prevents the redirect so we can perform the next action
  trackTrackingUrlClicked(sourcePage); // fire Segment event
  window.open(trackingUrl, '_blank'); // open trackingUrl in a new tab
};

const TrackingUrlLink = ({ trackingId, trackingUrl, itemId }) => {
  const trackingLabelId = `tracking-label-${itemId}`;
  const { sourcePage } = useContext(SourcePageContext);

  return (
    <Link
      target="_blank"
      href={trackingUrl}
      aria-labelledby={trackingLabelId}
      onClick={e => handleTrackingUrlClicked(e, trackingUrl, sourcePage)}
    >
      {trackingId}
    </Link>
  );
};

TrackingUrlLink.propTypes = {
  trackingId: PropTypes.string,
  trackingUrl: PropTypes.string,
  itemId: PropTypes.string,
};

export default TrackingUrlLink;
